import { getData, postData, putData } from 'src/api/http.service';
import {
  generateUserInfoHeader,
  getAPIEndpoints,
  handleApiError,
  handleApiSuccess,
} from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import { SubjectStatusEnum } from 'src/models';

const SubjectReviewActionTypes = {
  ALL_FINISHED_SUBJECTS_SUCCESS: '[API] : Get all finished subjects action.',
  REVERT_OR_DECLINE_SUBJECT: '[API] : Revert or decline subject.',
  REVERT_OR_DECLINE_SUBJECT_SUCCESS: '[API] : Revert or decline subject success.',
  APPROVE_A_SUBJECT: '[API] : Approve a subject action.',
  APPROVE_A_SUBJECT_SUCCESS: '[API] : Approve a subject success.',
};

/*
    Plain Actions
*/

function AllFinishedSubjectsSuccessAction(payload) {
  return {
    type: SubjectReviewActionTypes.ALL_FINISHED_SUBJECTS_SUCCESS,
    payload,
  };
}

function DeclineSubjectActionSuccess(payload) {
  return {
    type: SubjectReviewActionTypes.REVERT_OR_DECLINE_SUBJECT_SUCCESS,
    payload,
  };
}

function ApproveSubjectSuccessAction(payload) {
  return {
    type: SubjectReviewActionTypes.APPROVE_A_SUBJECT_SUCCESS,
    payload,
  };
}

/*
    Async Actions
*/

function GetAllFinishedSubjectsAction(metaData) {
  const url = getAPIEndpoints().getSubjectsByStatus.replace('{status}', SubjectStatusEnum.Finished);
  const headers = generateUserInfoHeader();
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(url, headers);
      if (response && response.data) {
        dispatch(AllFinishedSubjectsSuccessAction(response.data));
        dispatch(ApiCallSuccessAction(handleApiSuccess(response.data, metaData)));
        return true;
      }
      return false;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function DeclineSubjectAction(subjectId, metaData) {
  const url = getAPIEndpoints().declineSubject.replace('{subjectId}', subjectId);
  const headers = generateUserInfoHeader();
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await putData(url, null, headers);
      dispatch(DeclineSubjectActionSuccess(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

function ApproveSubjectAction(body) {
  const headers = generateUserInfoHeader();
  const url = getAPIEndpoints().approveSubject;
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await postData(url, body, headers);
      dispatch(ApproveSubjectSuccessAction(response.data.data));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return false;
    }
  };
}

export {
  SubjectReviewActionTypes,
  AllFinishedSubjectsSuccessAction,
  DeclineSubjectActionSuccess,
  ApproveSubjectSuccessAction,
  GetAllFinishedSubjectsAction,
  DeclineSubjectAction,
  ApproveSubjectAction,
};
